<script>
import Layout from '@layouts/main'
import GenreGridBlock from '@components/genre/genre-grid-block'

export default {
    page() {
        const title = 'Browse Genres'
        const description = 'Browse FRISKY by genre — house, techno, progressive, deep, and more.'
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    components: { Layout, GenreGridBlock },
    data() {
        return {
            isReady: true,
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters['auth/loggedIn']
        },
        followedGenreIds() {
            return this.$store.getters['favorites/genreIds']
        },
        activeGenres() {
            return this.$store.getters['genres/activeGenres']
        },
    },
    methods: {
        async handleToggleFollow(genre) {
            if (!this.isLoggedIn) {
                this.$router.push({ name: 'login' })
                return
            }

            if (!this.isReady || !genre) return

            this.isReady = false

            try {
                const isFollowing = this.followedGenreIds.includes(genre.id)
                await this.$store.dispatch(isFollowing ? 'favorites/remove' : 'favorites/add', {
                    type: 'genres',
                    id: genre.id,
                })
                this.$store.dispatch('appearance/handleNotification', {
                    message: isFollowing ? 'Genre Unfollowed' : 'Following Genre',
                    type: 'success',
                })
            } catch (error) {
                console.error('Error toggling genre follow:', error)
                this.$store.dispatch('appearance/handleNotification', {
                    message: this.$m('SOMETHING_WENT_WRONG'),
                    type: 'warning',
                })
            } finally {
                this.isReady = true
            }
        },
    }
}
</script>

<template>
    <Layout>
        <BaseContent title="Genres & Moods">
            <BaseSection padded>
                <GenreGridBlock
                    :genres="activeGenres"
                    :followed-genre-ids="followedGenreIds"
                    @toggle-follow="handleToggleFollow"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
